import logo from "./../assets/img/LOGO.png";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoginService from "./../Method/Login_Service";
import InputText from "./../Component/Input/Input";
function LogIn() {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleClear = () => {
    setEmail("");
    setPassword("");
    setError("");
  };
  const Login = async (e) => {
    e.preventDefault();
    try {
      const response = await LoginService.login(email.toLocaleUpperCase(), password.toLocaleUpperCase());

      if (response.success) {
        navigate("/home");
        handleClear();
      } else {
        setError(response.error);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div dir="ltr" className="container  login-container">
      <div className="row p-3 login-box-area">
        {/* Web Info */}
        <div className="col-md-6 login-left-box">
          <div className="featured-image">
            <img src={logo} className="login-img" alt="Logo_Img" />
          </div>

        </div>
        {/* Login Input */}
        <div className="col-md-6 login-right-box">
          <div className="align-items-center justify-content-center text-center">
            <div className="mb-4">
              <h2 className="login-welcome">{t("Welcome")}</h2>
            </div>
            <form
              method="GET"
              onSubmit={Login}
              className="input-groups"
              style={{ width: "80% !important", margin: "0 auto" }}
            >
              <InputText
                type="text"
                required
                labels={t("Email_Input")}
                onChange={(value) => setEmail(value)}
              />
              <InputText
                type="password"
                required
                labels={t("Password_Input")}
                onChange={(value) => setPassword(value)}
              />

              {error && <p className="error-message">{error}</p>}

              <button type="submit" className="login-btn mt-4">
                {t("Login_Btn")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogIn;
